import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        ...useState(),
    },
    getters: {
        ...useGetters(),
        chatId: state => state.list.length ? state.list[0].chat_id : null,
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
    },
}
